'use client';

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

export default GoogleReCaptchaProvider
